module.exports = __webpack_public_path__ + "img/news1.7a5bb03e.png";